import type { PageBaseTabs } from "@/page/base/PageBase";

/**
 * Observability 탭 어휘다. 조회 경로 여섯 개 중 **다섯 개**가 탭이 된다.
 *
 * `summary`(수집 건강)는 탭이 아니다. 이 메타 정보는 "지금 보는 지표를 믿어도 되는가" 에 먼저
 * 답한다. 탭 뒤에 숨기면 사용자가 보지 않는다. 그러면 수집이 멈춘 구간의 빈 차트를 "값이 0
 * 이었다" 로 읽는다. 그래서 창 선택과 같은 줄에 readout 으로 항상 표시한다.
 *
 * Owns: 탭 값 어휘와 URL 정규화, 탭 라벨.
 * Does not own: 탭별 본문(각 패널). 창 어휘(`observabilityWindow.ts`).
 */

export const OBSERVABILITY_TAB_PARAM = "tab";

export const observabilityTabValues = [
  "database",
  "tables",
  "queries",
  "runtime",
  "latency",
] as const;
export type ObservabilityTab = (typeof observabilityTabValues)[number];

export const defaultObservabilityTab: ObservabilityTab = "database";

export const observabilityTabItems: PageBaseTabs["items"] = [
  { value: "database", label: "데이터베이스" },
  { value: "tables", label: "테이블" },
  { value: "queries", label: "쿼리" },
  { value: "runtime", label: "API 런타임" },
  { value: "latency", label: "지연" },
];

/**
 * 표 하나가 본문 전체인 탭이다. 셸이 아니라 표가 스크롤을 소유한다(rules.md §14).
 *
 * 나머지 두 탭(데이터베이스·API 런타임)은 차트와 타일이 세로로 쌓이는 문서형이라 셸이 스크롤한다.
 */
export function isObservabilityTableTab(tab: ObservabilityTab): boolean {
  return tab === "tables" || tab === "queries" || tab === "latency";
}

/** 어휘 밖의 값(이전 링크·오타)은 기본 탭으로 바꾼다. */
export function normalizeObservabilityTab(value: string | null): ObservabilityTab {
  return observabilityTabValues.includes(value as ObservabilityTab)
    ? (value as ObservabilityTab)
    : defaultObservabilityTab;
}
